import {
  DEFAULT_QUOTATION_INTRO,
  DEFAULT_PAYMENT_TERMS,
  DEFAULT_TERMS_AND_CONDITIONS,
} from "../constants/quotationPdfDefaults";
import { computeAceQuotationTotals } from "./aceQuotationTotals";

function quotationToTotalsInput(q) {
  if (!q) return {};
  return {
    transportationChargesAmount: q.transportationChargesAmount,
    carTransportationChargesAmount: q.carTransportationChargesAmount,
    loadingChargesAmount: q.loadingChargesAmount,
    unloadingChargesAmount: q.unloadingChargesAmount,
    unpackingRearrangingChargesAmount: q.unpackingRearrangingChargesAmount,
    shuttleLongCarryEscortChargesAmount: q.shuttleLongCarryEscortChargesAmount,
    carrierRiskChargesAmount: q.carrierRiskChargesAmount,
    gstAmount: q.gstAmount,
    gstPercent: q.gstPercent,
  };
}

/**
 * Normalizes GET /quotations/:id response for QuotationPDF.
 */
function normalizeTerms(raw) {
  if (Array.isArray(raw) && raw.length) {
    return raw.map((t) => String(t == null ? "" : t).trim()).filter(Boolean);
  }
  return [...DEFAULT_TERMS_AND_CONDITIONS];
}

export default function buildQuotationPdfData(apiResponse) {
  if (!apiResponse || typeof apiResponse !== "object") {
    throw new Error("Invalid quotation data for PDF");
  }
  const qRaw = apiResponse.quotation ? { ...apiResponse.quotation } : { ...apiResponse };
  const items = Array.isArray(apiResponse.items) ? apiResponse.items : [];
  const fin = computeAceQuotationTotals(quotationToTotalsInput(qRaw));
  const quotation = {
    ...qRaw,
    subTotal: fin.subTotal,
    gstAmount: fin.gstAmount,
    totalAmount: fin.totalAmount,
  };

  const terms = normalizeTerms(quotation.termsAndConditions);

  return {
    quotation,
    items,
    vehicles: Array.isArray(quotation.vehicles) ? quotation.vehicles : [],
    intro: String((quotation.quotationIntro || "").trim() || DEFAULT_QUOTATION_INTRO),
    paymentTerms: String((quotation.paymentTerms || "").trim() || DEFAULT_PAYMENT_TERMS),
    terms: terms.length ? terms : [...DEFAULT_TERMS_AND_CONDITIONS],
  };
}
